























































import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import {FormRowWings, SelectWings, DatePickerWings} from '@/components';

@Component({components: {FormRowWings, SelectWings, DatePickerWings}})
export default class PushFilters extends Vue {
  @Prop() filter!: any;
  @Prop() attributesList!: any;

  RELATION_AND = '&&';
  RELATION_OR = '||';

  private filterItems: any[] = []

  private availableFilters = {
    String: [
      {name: this.$t('push_filters.string.empty'), filterTemplate: '#{attribute} == null', itemTemplate: '{attribute} '+ this.$t('push_filters.string.empty'), parametersCount: 0},
      {name: this.$t('push_filters.string.not_empty'), filterTemplate: '#{attribute} != null', itemTemplate: '{attribute} '+ this.$t('push_filters.string.not_empty'), parametersCount: 0},
      {name: this.$t('push_filters.string.not_contains'), filterTemplate: '!like(#{attribute}, \'{0}\')', itemTemplate: '{attribute} '+ this.$t('push_filters.string.not_contains') + ' {0}', parametersCount: 1},
      {name: this.$t('push_filters.string.contains'), filterTemplate: 'like(#{attribute}, \'{0}\')', itemTemplate: '{attribute} '+ this.$t('push_filters.string.contains') + ' {0}', parametersCount: 1},
      {name: this.$t('push_filters.string.starts'), filterTemplate: 'start(#{attribute}, \'{0}\')', itemTemplate: '{attribute} '+ this.$t('push_filters.string.starts') + ' {0}', parametersCount: 1},
      {name: this.$t('push_filters.string.ends'), filterTemplate: 'end(#{attribute}, \'{0}\')', itemTemplate: '{attribute} '+ this.$t('push_filters.string.ends') + ' {0}', parametersCount: 1},
      {name: this.$t('push_filters.string.equal'), filterTemplate: '#{attribute} == \'{0}\'', itemTemplate: '{attribute} = {0}', parametersCount: 1}
    ],
    Number: [
      {name: this.$t('push_filters.number.empty'), filterTemplate: '#{attribute} == null', itemTemplate: '{attribute} '+ this.$t('push_filters.number.empty'), parametersCount: 0},
      {name: this.$t('push_filters.number.not_empty'), filterTemplate: '#{attribute} != null', itemTemplate: '{attribute} '+ this.$t('push_filters.number.not_empty'), parametersCount: 0},
      {name: this.$t('push_filters.number.equal'), filterTemplate: '#{attribute} == {0}', itemTemplate: '{attribute} = {0}', parametersCount: 1},
      {name: this.$t('push_filters.number.not_equal'), filterTemplate: '#{attribute} != {0}', itemTemplate: '{attribute} != {0}', parametersCount: 1},
      {name: this.$t('push_filters.number.greater'), filterTemplate: '#{attribute} > {0}', itemTemplate: '{attribute} > {0}', parametersCount: 1},
      {name: this.$t('push_filters.number.greater_equal'), filterTemplate: '#{attribute} >= {0}', itemTemplate: '{attribute} >= {0}', parametersCount: 1},
      {name: this.$t('push_filters.number.lower'), filterTemplate: '#{attribute} < {0}', itemTemplate: '{attribute} < {0}', parametersCount: 1},
      {name: this.$t('push_filters.number.lower_equal'), filterTemplate: '#{attribute} <= {0}', itemTemplate: '{attribute} <= {0}', parametersCount: 1},
      {name: this.$t('push_filters.number.between'), filterTemplate: 'between(#{attribute}, {0}, {1})', itemTemplate: '{0} > {attribute} < {1}', parametersCount: 2},
      {name: this.$t('push_filters.number.not_between'), filterTemplate: '!between(#{attribute}, {0}, {1})', itemTemplate: '{attribute} < {0} '+this.$t('push_filters.or')+' {attribute} > {1}', parametersCount: 2}
    ],
    Date: [
      {name: this.$t('push_filters.date.empty'), filterTemplate: '#{attribute} == null', itemTemplate: '{attribute} '+ this.$t('push_filters.date.empty'), parametersCount: 0},
      {name: this.$t('push_filters.date.not_empty'), filterTemplate: '#{attribute} != null', itemTemplate: '{attribute} '+ this.$t('push_filters.date.not_empty'), parametersCount: 0},
      {name: this.$t('push_filters.date.equal'), filterTemplate: 'dateEqual(#{attribute}, \'{0}\')', itemTemplate: '{attribute} = {0}', parametersCount: 1},
      {name: this.$t('push_filters.date.before'), filterTemplate: 'dateBefore(#{attribute}, \'{0}\')', itemTemplate: '{attribute} < {0}', parametersCount: 1},
      {name: this.$t('push_filters.date.after'), filterTemplate: 'dateAfter(#{attribute}, \'{0}\')', itemTemplate: '{attribute} > {0}', parametersCount: 1},
      {name: this.$t('push_filters.date.between'), filterTemplate: 'dateBetween(#{attribute}, \'{0}\', \'{1}\')', itemTemplate: '{0} > {attribute} < {1}', parametersCount: 2}
    ]
  };

  addItem(relation:any = null, attribute:any = null, filter:any = null, parameters:any = []) {
    this.filterItems.push({
      relation: relation || null,
      attribute: attribute?.AttributeName || null,
      attributeType: attribute?.AttributeType || null,
      filter: filter || null,
      filterName: filter?.name || null,
      parameters: parameters || []
    })
  }

  deleteItem(idx: number) {
    this.filterItems.splice(idx, 1)
    if (this.filterItems.length == 0) this.$emit('result', undefined)
  }

  toggleRelation(filter:any) {
    filter.relation = filter.relation == this.RELATION_AND ? this.RELATION_OR :  this.RELATION_AND
  }

  getClassForDeleteBtn(count: number) {
    if (count == 0) return 'md-size-50'
    if (count == 1) return 'md-size-30'
    return 'md-size-10'
  }

  @Watch('filter', {immediate: true})
  onChangeFilter(val: string, oldVal?: string) {
    if (!val) {
      this.filterItems = []
      return
    }
    this.parseItems(this.filter)
  }

  @Watch('attributesList', {immediate: true})
  onChangeAttributesList(val: string, oldVal?: string) {
    if (!val) {
      this.filterItems = []
      return
    }
    this.parseItems(this.filter)
  }

  @Watch('result', {immediate: true})
  onChangeResult(val: string, oldVal?: string) {
    if (!val) return
    this.$emit('result', this.result)
  }

  updateFilter(selfItem: any) {
    selfItem.filter = this.getFilter(selfItem.filterName, selfItem.attributeType)

    var parameters: any = [];
    if (selfItem.filter === null || !selfItem.filter.parametersCount) {
        selfItem.parameters = parameters;
        return
    }
    for (var i = 0; i < selfItem.filter.parametersCount; i++) {
        var parameterValue = '';
        if (selfItem.parameters[i]){
            parameterValue = selfItem.parameters[i]
        }
        parameters.push(parameterValue);
    }
    selfItem.parameters = parameters
  }

  getFilter(name: string, type: string) {
    // @ts-ignore
    for (var i in this.availableFilters[type]) {
      // @ts-ignore
      var filter = this.availableFilters[type][i];
      if (filter.name == name) {
        return filter
      }
    }
    return null
  }

  updateAttribute(filter: any) {
    filter.attributeType = this.getAttributeType(filter.attribute)
  }

  getAttributeType(name:string) {
    return this.attributesList.find((item:any) => item.AttributeName == name)?.AttributeType
  }

  parseItems(value:string) {
    if (!value || value === this.result) return

    this.filterItems = [];

    var parts = value.split('&&');
    for (var i in parts) {
      var part = parts[i].split('||');
      for (var j = 0; j < part.length; j++) {
        var attribute = this.parseAttribute(part[j]);
        if (!attribute) {
          this.addItem()
          continue;
        }

        var filter = this.parseFilter(attribute.AttributeType, part[j]);

        if (j === 0) {
          this.addItem(this.RELATION_AND, attribute, filter, this.extractParameters(filter, part[j]));
        } else {
          this.addItem(this.RELATION_OR, attribute, filter, this.extractParameters(filter, part[j]));
        }
      }
    }
    this.filterItems[0].relation = null;
  }

  parseAttribute(value:string) {
    // @ts-ignore
    const match = value.match('#(\\w+)')[1];
    for (var i in this.attributesList) {
      if (this.attributesList[i].AttributeName === match) {
        return this.attributesList[i];
      }
    }
    return null;
  }

  parseFilter(type:any, value:any) {
    // @ts-ignore
    for (var i in this.availableFilters[type]) {
      // @ts-ignore
      var filter = this.availableFilters[type][i];
      if (this.match(filter, value)) {
        return filter;
      }
    }
    return null;
  }

  createRegExp(filterTemplate:string, parametersCount:number) {
    let pattern = filterTemplate;
    pattern = pattern.replace('(', '\\(');
    pattern = pattern.replace(')', '\\)');
    pattern = pattern.replace('{attribute}', '(\\w+)');
    for (var i = 0; i < parametersCount; i++) {
      pattern = pattern.replace('{'+ i +'}', '(.*)');
    }
    return new RegExp(pattern);
  }

  renderFilter(item:any) {
    let response = item.filter.filterTemplate;
    response = response.replace('{attribute}', item.attribute);
    for (var i = 0; i < item.filter.parametersCount; i++) {
      if (!item.parameters[i]) return null
      response = response.replace('{'+ i +'}', item.parameters[i]);
    }
    return response;
  }

  renderItem(item:any) {
    let response = item.filter.itemTemplate.toLowerCase();
    response = response.replace(/\{attribute\}/g, '<span>'+item.attribute+'</span>');
    for (var i = 0; i < item.filter.parametersCount; i++) {
      if (!item.parameters[i]) return this.$t('push_filters.incorrect')
      response = response.replace('{'+ i +'}', '<span>'+item.parameters[i]+'</span>');
    }
    return response;
  }

  match(filter: any, value:any) {
    return this.createRegExp(filter.filterTemplate, filter.parametersCount).exec(value) !== null
  }

  extractParameters(filter: any, value:any) {
    if (filter.parametersCount === 0) return []

    const result = this.createRegExp(filter.filterTemplate, filter.parametersCount).exec(value)
    if (result === null) {
      return new Array(filter.parametersCount).fill(null);
    }

    let parameters = [];
    for (var i = 0; i < filter.parametersCount; i++) {
      parameters.push(result[i + 2]);
    }

    return parameters;
  }

  get result() {
    if (this.filterItems.length === 0) return ''

    let items = [];
    for (var i in this.filterItems) {
      let filter = '';
      const item = this.filterItems[i];

      if (!item.attribute) continue;
      if (!item.filter) continue;

      if (item.relation) {
        filter += item.relation + ' ';
      }

      var response = this.renderFilter(item);
      if (!response) continue;
      filter += response;

      items.push(filter);
    }

    if (items.length === 0) return ''

    return items.join(' ');
  }
}
